<!--
 * @Author: your name
 * @Date: 2021-04-27 11:20:18
 * @LastEditTime: 2021-09-08 09:55:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /project-logic/component/commonPages/WelcomePage.vue
-->
<template>
  <!-- <div class="welcomepage">
    <div class="themeT">
      <el-color-picker v-model="color1" @change="colorPick" :predefine="predefineColors"></el-color-picker>
    </div>
    <ul class="colorFade">
      <li>111</li>
      <li>222</li>
      <li>333</li>
    </ul>
  </div> -->
  <monitorPlatformOne />

</template>

<script>
import { mapState } from "vuex";
import monitorPlatformOne from 'allpages/monitorPlatform/monitorPlatformOne.vue';
import { setInputRegex } from '@/config/config/setRegex.js';
export default {
  name: "WelcomePage",
  data() {
    return {
      color1: '#409EFF',
      predefineColors: [
        // '#f1b8f1', // 马卡龙粉
        '#FFC0CB',
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        // '#00cex1',
        '#3870c1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        // 'hsv(51, 100, 98)',
        // 'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      ColorMatch: {
        // "#F1B8F1":"#b8f1ed",
        "#FFC0CB":"#8A2BE2", // 粉-天蓝
        // "#FF4500"
        // "#FF8C00"
        // "#FFD700"
        // "#90EE90"
        // "#3870C1"
        // "#1E90FF"
        // "#C71585"
        // "#FF4500"
        // "#FF7800"
        // "#00BABD"
        // "#1F93FF"
        // "#C71585"
      },
    };
  },
  computed: {
    ...mapState('global', ['menuLists', 'userInfo']),
  },
  components:{
    monitorPlatformOne,
  },
  created() {
    // 外键关联表格每页条数动态设置
    if (!localStorage.getItem('fkRange')) {
      this.fkRange()
    } else {
      this.setComponentsProps()
    }
  },
  methods: {
    colorPick(val) {
      this.color1 = val
      this.changeColor(val)
    },
    Co(x,y) {
        document.documentElement.style.setProperty(x,y);
    },
    changeColor(val) {
      console.log('-----pick::', val);
      // document.documentElement 代表相关的容器如：#box
      //js中获取--b1-color的值
      var value = getComputedStyle(document.documentElement).getPropertyValue("--b1-color");

      if (!val) {
        const initTheme = {
          "--b1-color": "#3870c1",
          "--b1-color_x1": "#1256b9",
          "--b1-color_q1": "#ABCDEF",
          "--b2-color": "#fd6442",
          "--b2-color_q1": "#fdd2c9",
          "--b2-color_x1": "#ed4014",
          "--t-text": "#fff"
        }
        for (const it of Object.entries(initTheme)) {
          this.Co(it[0],it[1])
        }
        return
      }
      // 颜色深度处理
      const Color = require('color');
      let b1, b1x1, b1q1, b2;
      b1 = Color(val)
      const {r, g, b} = b1.object()

      b1q1 = b1.lighten(0.1).hex()
      b1x1 = b1.saturate(0.7).darken(0.2).hex()
      b2 = b1.saturate(0.75).rotate(155).lighten(0.3); // 逆时针

      if(r*0.299 + g*0.578 + b*0.114 >= 172){ // 浅色 192
        this.Co("--t-text","#17233d");
        b2 = b1.darken(0.4).rotate(-80); // .desaturate(0.75)
      } else {
        this.Co("--t-text","#fff");
      }

      let formatColor = [];
      for (const it of this.predefineColors) {
        formatColor.push(Color(it).hex())
      }

      if (formatColor.includes(val)) {
        b2 = this.ColorMatch[val]
      }

      console.log(this.predefineColors,formatColor);

      this.Co("--b1-color",val);
      this.Co("--b1-color_x1",b1x1);

      this.Co("--color1","#87CEEB");
      this.Co("--color2",b2);
      this.Co("--color3",b1.darken(0.4).rotate(-90));

      this.Co("--b2-color",b2);
      this.Co("--b2-color_q1",b2.lighten(0.2));
      this.Co("--b2-color_x1",b2.darken(0.2));
    },
    openMenu() {
      if (!this.userInfo) return
      let menuLists = this.$store.state.global.openedMenuLists;
      if (menuLists.length > 0) {

      } else {
        /* 导航栏为空时，直接添加默认Tab */
        R3.store.commit("global/tabOpen", {
          type: "C",
          label: '概览',
          url: '/CUSTOMIZED/OVERVIEW/41460840',
          customizedModuleName: 'OVERVIEW',
          customizedModuleId: '41460840',
        });
      }
    },
    fkRange() {
      this.service.common.getForeignKeyFiltersRows().then(({ data: { code, data } }) => {
        if (code == 0) {
          localStorage.setItem('fkRange', data)
        }
      }).catch(() => {
        localStorage.setItem('fkRange', 10)
      })
      this.setComponentsProps()
    },
    setComponentsProps() {
      window.ProjectConfig.setComponentsProps = (type, props = {}) => {
        if (type === 'OBJ_SELECT') {
          // props.chooseAll = false;
          props.multipleType = true; // 取消全选
          props.filterable = true; // 开启模糊搜索
        }
        if (type === 'String' && props.options.colname == 'TEST') {
          // props.customizedDefaultValue = $pageNote[props.options.tableName];
        }
        // 下拉多选 添加模糊查询多选功能
        if (type === 'OBJ_FK') {
          if (props.PropsData.fkobj.searchmodel === 'mrp') {
            props.filterMode = true;
          }
          props.PropsData.pageSize = Number(localStorage.getItem('fkRange') || 20)
        }
        setInputRegex(props);
        return props;
      }
    },
  },
  mounted() {
    const conf = JSON.parse(localStorage.getItem('userInfo'))
    if (!conf && !document.querySelector('.blankSkeleton') && vm.$route.fullPath == '/') {
      const str = `<div class="el-skeleton is-animated"
                        style="display: flex; flex-direction: column; justify-content: space-around; width: 100vw; height: 100vh;">
                      <div class="el-skeleton__item el-skeleton__p is-first"><!----></div><div class="el-skeleton__item el-skeleton__p el-skeleton__paragraph"><!----></div><div class="el-skeleton__item el-skeleton__p el-skeleton__paragraph"><!----></div><div class="el-skeleton__item el-skeleton__p el-skeleton__paragraph"><!----></div><div class="el-skeleton__item el-skeleton__p el-skeleton__paragraph"><!----></div><div class="el-skeleton__item el-skeleton__p el-skeleton__paragraph is-last"><!----></div>
                  </div>`
      let blankDom = document.createElement('div');
      blankDom.className = 'blankSkeleton';
      blankDom.style = "position: fixed; inset: 0; background: #fff; z-index: 100; "
      blankDom.innerHTML = str
      document.body.appendChild(blankDom)
      return
    }
    const domContent = document.getElementById("content");
    domContent.style.padding = "0 0";
    setTimeout(() => {
      vm.$cusMark()
    }, 200);
    /* setTimeout(() => {
      this.openMenu()
    }, 3000); */
  },
  watch: {
    '$store.state.global.openedMenuLists': {
      handler(val) {
        console.log(val)
      }
    }
  },
  destroyed() {
    if (document.getElementById("content")) {
      const domContent = document.getElementById("content");
      domContent.style.padding = "0 15px";
    }
  },
};
</script>

<style scoped lang="less">
:root {
  --color1: #ddd;
  --color2: #ddd;
  --color3: #ddd;
}
@import 'omsTheme/index.less';
.welcomepage {
  width: 100%;
  height: 100%;
  // background: url("/src/assets/img/welBgCh1.jpg") center / 100% no-repeat #fff;
  background-size: auto 100%;
  /deep/ .ark-dropdown {
    margin: 10px 10px 20px;
  }
  .container {
    z-index: 999;
    padding: 20px;
    background-color: rgb(252, 252, 247);
    button {
      height: 24px;
      width: 60px;
      border-radius: 2px;
      border: 1px solid @button-border;
      color: @button-border;
      background-color: @button-bg-font;
      margin-right: 20px;
    }
    span {
      font-size: 16px;
      text-align: left;
    }
  }
}
.colorFade {
  display: none;
  position: absolute;
  right: 100px;
  top: 300px;
  li {
    color: #fff;
    margin: 20px;
    height: 50px;
    width: 100px;
    border: 1px solid;
    &:first-child {
      background-color: var(--color1);
    }
    &:nth-child(2) {
      background-color: var(--color2);
    }
    &:nth-child(3) {
      background-color: var(--color3);
    }
  }
}
.themeT {
  display: none;
  z-index: 999;
  position: fixed;
  top: 60px;
  right: 150px;
  button {
    width: 60px;
    height: 30px;
    border: 1px solid red;
    background: #fff;
    color: var(--b1-color);
  }
}
</style>
